<template>
  <div class="inner-vacancy">
    <div v-if="!loaded" class="inner-vacancy__preloader">
      <vpreloader />
    </div>

    <div v-if="loaded && id" class="inner-vacancy__wrapper">
      <vacancy-sidebar v-if="modules_loaded" class="inner-vacancy__sidebar" />

      <div class="inner-vacancy__content">
        <router-view :vacancy-id="id" @loaded="update" />
      </div>
    </div>

    <div
      v-if="opacity > 0 || pagePosition"
      :style="{ opacity: pagePosition ? 1 : opacity }"
      class="scroll-box"
      @click="scroll"
    >
      <div class="scroll-box-btn" :class="{ 'is-down': pagePosition }">
        <svg
          class="scroll-box-icon"
          width="12"
          height="7"
          viewBox="0 0 12 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.61737 6.23349L6.08206 2.69818L2.54676 6.23348C2.1914 6.58884 1.61737 6.58884 1.26202 6.23348C0.906664 5.87813 0.906664 5.3041 1.26202 4.94875L5.44425 0.766514C5.7996 0.411161 6.37363 0.411161 6.72899 0.766514L10.9112 4.94875C11.2666 5.3041 11.2666 5.87813 10.9112 6.23349C10.5559 6.57973 9.97272 6.58884 9.61737 6.23349Z"
            fill="currentColor"
          />
        </svg>
        <span>{{ $tr('common.up') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import scrollTo from '@/_helpers/scrollTo.js';
import VacancySidebar from '@/routes_new/inner/vacancy/components/VacancySidebar';

export default {
  name: 'InnerVacancy',

  components: {
    VacancySidebar
  },

  beforeRouteUpdate(to, from, next) {
    this.opacity = 0;
    this.scrollPos = 0;
    this.pagePosition = 0;
    this.isScrolledToTop = false;

    if (this.unsavedChanges) {
      if (this.canGo()) {
        this.resetChangesTimestamps();
        next();
        window.onbeforeunload = null;
      } else {
        // Hotfix for progressbar
        // setTimeout(() => this.$nprogress.done(), 100)
        next(false);
      }
    } else {
      next();
      window.onbeforeunload = null;
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.unsavedChanges) {
      if (this.canGo()) {
        this.resetChangesTimestamps();
        next();
        window.onbeforeunload = null;
      } else {
        // Hotfix for progressbar
        // setTimeout(() => this.$nprogress.done(), 100)
        next(false);
      }
    } else {
      next();
      window.onbeforeunload = null;
    }
  },

  props: {
    id: {
      type: [Number, String],
      default: 0
    }
  },

  data() {
    return {
      opacity: 0,
      scrollPos: 0,
      pagePosition: 0,
      isScrolledToTop: false
    };
  },

  computed: {
    ...mapGetters('vacancy_new', ['loaded', 'process']),

    ...mapGetters('vacancy_new/modules', { modules_loaded: 'loaded' }),

    ...mapGetters('vacancy', {
      vacancy: 'one',
      unsavedCompetencies: 'haveUnsavedChangesCompetencies',
      unsavedBasic: 'haveUnsavedChanges',
      unsavedInvitations: 'invitation/haveUnsavedChanges',
      unsavedSms: 'sms/haveUnsavedChanges',
      unsavedVideointerview: 'videointerview/haveUnsavedChanges'
    }),

    unsavedChanges() {
      return (
        this.unsavedInvitations ||
        this.unsavedSms ||
        this.unsavedVideointerview ||
        this.unsavedCompetencies ||
        this.unsavedBasic
      );
    },

    isAccessDenied() {
      if (!this.vacancy) {
        return false;
      }

      return this.vacancy.role === 'role_read' || this.vacancy.role === 'role_read_scoring';
    }
  },

  watch: {
    vacancyId() {
      this.fetch();
    },

    isAccessDenied: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.$router.push({ name: 'vacancies' });
        }
      }
    }
  },

  created() {
    this.$store.dispatch('vacancy_new/load', this.id);
    this.$store.dispatch('vacancy_new/modules/load', this.id);

    window.addEventListener('scroll', this.scrollListener);
  },

  beforeMount() {
    this.fetch();
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollListener);
    this.$store.commit('vacancy/clear');
    this.$store.dispatch('vacancy/clearPermissions');
    this.resetChangesTimestamps();
  },

  methods: {
    fetch() {
      this.id && this.$store.dispatch('vacancy/fetchVacancy', { id: this.id });
      this.$store.dispatch('company/fetch');
      this.$store.dispatch('vacancy/invitation/fetch', { vacancyId: this.id });
    },

    canGo() {
      return this.unsavedChanges ? window.confirm(this.$tr('vacancy.preferences.modals.leaveUnsavedData')) : false;
    },

    resetChangesTimestamps() {
      this.$store.commit('vacancy/resetChangesTimestamps');
      this.$store.commit('vacancy/invitation/resetChangesTimestamps');
      this.$store.commit('vacancy/sms/resetChangesTimestamps');
      this.$store.commit('vacancy/videointerview/resetChangesTimestamps');
    },

    update(data) {
      // data - some data, key main;
      switch (data.key) {
        case 'example_action': {
          // что то делаем если требуется
          break;
        }
      }
    },

    scroll() {
      if (!this.pagePosition || this.pagePosition === window.pageYOffset) {
        this.pagePosition = window.pageYOffset;
        scrollTo(0);
      } else {
        scrollTo(this.pagePosition);
      }
    },

    scrollListener() {
      let scrollOffset = window.pageYOffset;

      if (scrollOffset > 400) {
        this.opacity = 1;
      } else if (scrollOffset > 200) {
        this.opacity = (scrollOffset - 200) / 200;
      } else {
        this.opacity = 0;
      }

      if (document.body.getBoundingClientRect().top <= this.scrollPos) {
        if (scrollOffset > 200 && scrollOffset < 400) {
          this.pagePosition = 0;
        }
      }

      this.scrollPos = document.body.getBoundingClientRect().top;
    }
  }
};
</script>

<style lang="scss" scoped>
.inner-vacancy {
  position: relative;

  &__preloader {
    margin: 60px auto 0;
  }

  &__wrapper {
    display: flex;
  }

  &__sidebar {
    position: relative;
    width: 300px;
    padding: 20px 0;
    background: #fff;
  }

  &__content {
    background: $background;
    padding: 30px;
    flex: 1;
  }
}

.scroll-box {
  position: absolute;
  top: 0;
  right: 0;
  width: 80px;
  height: 100%;
  text-align: center;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 100%;
  color: #9faab6;
  transition: opacity ease-in-out 0.4s, background ease-in-out 0.4s, color ease-in-out 0.4s;
  cursor: pointer;

  svg {
    color: #7f8b99;
    transition: all ease-in-out 0.4s;
  }

  &:hover {
    background: rgba(210, 214, 224, 0.1);
    opacity: 1 !important;
    color: #607182;

    svg {
      color: #607182;
    }
  }
}

.scroll-box-icon {
  margin-right: 3px;
}

.scroll-box-btn {
  position: -webkit-sticky;
  position: sticky;
  padding: 0 7px;
  top: 77px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;

  &.is-down {
    justify-content: center;
    width: 100%;
    padding-top: 3px;
    span {
      display: none;
    }

    svg {
      transform: rotate(180deg);
      margin-right: 0;
    }
  }
}

@media all and (-ms-high-contrast: none) {
  *::-ms-backdrop,
  .scroll-box {
    position: fixed;
  } /* IE11 */
  *::-ms-backdrop,
  .scroll-box-btn {
    position: absolute;
  } /* IE11 */
}
</style>
